import axios from 'axios';
import { apiPath } from '../constants/defaultValues';
export default axios.create({
  baseURL: apiPath,
  headers: {
    'Content-Type': 'application/json',
  }
});
